import { createGlobalStyle } from 'styled-components'

import { fontsFaces } from './fonts'
import { mq, pxToRem } from './mixins'
import sizes from './sizes'

export const GlobalStyles = createGlobalStyle`
  ${fontsFaces}
  // global css variables
  :root {
    --g_height__header: ${pxToRem(65)};
    --g_height__logo: calc(174 / 1440 * 100vw);
    --g_height__bottom: ${pxToRem(48)};
    --g_outline--focus: 1px dotted rgba(0, 0, 0, 0.5);
    --g_spacing__blocks: ${pxToRem(80)};
    --g_spacing__blocks--compact: ${pxToRem(80)};
  }
  * {
    box-sizing: border-box;
  }
  html {
    --g_font-size__big: calc(75% + 0.4vw);
    font-size: 100%;
    @media ${mq(sizes.maxMockups + 20)} {
      font-size: var(--g_font-size__big);
      font-size: round(to-zero, var(--g_font-size__big), 1px);
    }
  }
  html,
  body,
  #root {
    margin: 0;
    height: 100%;
  }
  body {
    padding: 0;
    margin: 0;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
  }
  body.with-menu--open {
    overflow: hidden;
  }
  p, ol, ul, h1, h2, h3, h4, h5, h6 {
    margin: 0;
    padding: 0;
  }
  a {
    &,
    &:hover {
      text-decoration: none;
    }
  }
  a[href] {
    cursor: pointer;
  }
  img {
    max-width: 100%;
    height: auto;
    vertical-align: middle
  }
  figure,
  picture,
  picture img {
    display: block;
    margin: unset;
  }
  button {
    padding: 0;
    border: 0;
    color: inherit;
    &:not(:disabled) {
      cursor: pointer;
    }
  }  
  :focus {
    outline: var(--g_outline--focus);
  }
  :focus:not(:focus-visible) {
    outline: none;
  }
  :focus-visible {
    outline: var(--g_outline--focus);
  }
  input::-ms-clear {
    display: none;
  }
  input[type="search"] {
    appearance: textfield;
  }
  input[type="search"]::-webkit-search-decoration,
  input[type="search"]::-webkit-search-cancel-button,
  input[type="search"]::-webkit-search-results-button,
  input[type="search"]::-webkit-search-results-decoration {
    -webkit-appearance: none;
    display: none;
  }
  @media ${mq(sizes.desktop)} {
  // global css variables
    :root {
      --g_spacing__blocks: ${pxToRem(200)};
      --g_spacing__blocks--small: ${pxToRem(104)};
    }
  }
  @media ${mq(sizes.big)} {
    // global css variables
    :root {
      --g_height__header: ${pxToRem(89)};
    }
  }
`
